// 投资云助手
export default {
  huanyingshiyong: '欢迎使用投资云助手',
}